import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconClipboard"><Path fillRule="evenodd" clipRule="evenodd" d="M16 2H8V4H4V22H20V4H16V2ZM14 4H10V6H14V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard;
